import { Snackbar } from '@mui/material';
import React from 'react';
import MuiAlert from '@mui/material/Alert';
import type { SlideProps } from '@mui/material';
import type { NotificationSeverity } from '../../app/types';

interface AlertSnackbarProps {
  open: boolean;
  transition?: React.ComponentType<SlideProps> | false;
  message?: string | false;
  setOpen: (open: boolean) => void;
  severity?: NotificationSeverity | false;
}

export default function AlertSnackbar({ open, transition, message, setOpen, severity }: AlertSnackbarProps) {
    const handleClose = () => {
        setOpen(false)
    };
    
    return (
        <>
        {open && message && <Snackbar
            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            TransitionComponent={transition || undefined}
            key={transition && 'name' in transition ? String(transition.name) : ''}
        >
            <MuiAlert onClose={handleClose} elevation={6} variant="filled" severity={severity || 'info'} sx={{color: 'white'}}>{message}</MuiAlert>
        </Snackbar>}
        </>
    )
}
